import user from './user'
import main from './main'
import tournament from './tournament'
import games from './games'
import finances from './finances'

export default (axios) => ({
  user: user(axios),
  main: main(axios),
  tournament: tournament(axios),
  games: games(axios),
  finances: finances(axios)
})



// WEBPACK FOOTER //
// ./src/pkg/api/index.js